/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---------------------------------------------------------------------------
 * Ex-VAT price for single-variant PDPs.            added 2026-09-20
 *
 * THE BUG
 * assets/ipl-pdp-a11y.js writes the "£x ex VAT" line under the price. It looks
 * the variant up in an index built from the page's JSON-LD, and buildIndex()
 * ends with:
 *
 *     return n > 1 ? map : null;
 *
 * A product with one variant yields n === 1, so INDEX is null, currentRecord()
 * returns null, and updatePriceExtras() hides #iplpPriceExtras. Every
 * single-variant product on the store therefore shows the inc-VAT price only.
 * Verified on live 2026-09-20: /products/a3-clear-acrylic-sheet-4mm-thickness-
 * pack-of-3-for-displays renders the node empty and hidden, while the
 * 12-variant /products/workplaces-matting renders "£375.00 ex VAT".
 *
 * WHY THE FIX IS HERE AND NOT THERE
 * The real fix is `n > 0` in that file, but themeFilesUpsert has no partial
 * write and ipl-pdp-a11y.js is 30KB of built output. Retyping it to change one
 * character is the larger risk. This is the JS counterpart of what
 * assets/ipl-design-system.css does for CSS.
 *
 * WHY IT CANNOT BREAK A WORKING PAGE
 * It returns immediately unless the page offers exactly one purchasable
 * combination, which is the case ipl-pdp-a11y.js abandons. On every
 * multi-variant product this block is a no-op and the a11y script still owns
 * the line. It also refuses to overwrite a non-empty node.
 *
 * WHEN buildIndex() IS FIXED AT SOURCE, DELETE THIS BLOCK.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.getElementById('iplp');
  if (!root) return;

  /* Only the shape ipl-pdp-a11y.js gives up on: one purchasable combination.
     Counted as the product of each axis's value count, so a product with two
     single-valued axes (still one variant, still broken) is covered too. */
  var combos = 1;
  Array.prototype.forEach.call(root.querySelectorAll('.iplp__opt'), function (o) {
    var sel = o.querySelector('[data-optselect]');
    var n = sel ? sel.options.length : o.querySelectorAll('[data-optpill]').length;
    combos *= (n || 1);
  });
  if (combos > 1) return;

  var VAT = typeof (window.IPLPDP || {}).vatRate === 'number'
    ? window.IPLPDP.vatRate
    : 0.2;

  /* Same construction and insertion point as ensurePriceExtras() in
     ipl-pdp-a11y.js, so the two paths cannot produce different markup. */
  function host() {
    var el = document.getElementById('iplpPriceExtras');
    if (el) return el;
    var row = root.querySelector('.iplp__pricerow');
    if (!row || !row.parentNode) return null;
    el = document.createElement('p');
    el.id = 'iplpPriceExtras';
    el.className = 'iplp__priceextras';
    row.parentNode.insertBefore(el, row.nextSibling);
    return el;
  }

  /* Mirrors money() in ipl-pdp-a11y.js, including the thousands separator. */
  function money(n, symbol) {
    var p = n.toFixed(2).split('.');
    return symbol + p[0].replace(/\B(?=(\d{3})+$)/g, ',') + '.' + p[1];
  }

  function fill() {
    var el = host();
    if (!el) return;
    if (el.textContent.trim()) return; /* a11y script got there first */

    var priceEl = document.getElementById('iplpBuyPrice');
    var text = priceEl ? priceEl.textContent : '';
    var symbol = (text.match(/[^\d\s.,]+/) || ['£'])[0];
    var amount = parseFloat((text.match(/[\d,]+\.?\d*/) || [''])[0].replace(/,/g, ''));

    /* "Price on request", empty, or anything unparseable: show nothing. */
    if (!isFinite(amount) || amount <= 0) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    el.textContent = money(amount / (1 + VAT), symbol) + ' ex VAT';
    el.hidden = false;
  }

  var timer = null;
  function soon() {
    clearTimeout(timer);
    timer = setTimeout(fill, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', soon);
  } else {
    soon();
  }
  window.addEventListener('load', soon);
}());
